<template>
  <div>
    <!-- category数据渲染 -->
    <div class="div">
      <el-row>
        <a
          href="###"
          :class="{ anchor: true, active: i == active }"
          v-for="(item, i) in goodsCategory"
          :key="item.id"
          @click="fun(i)"
        >
          {{ item.name }}
        </a>
      </el-row>
    </div>
    <div
      class="div"
      v-for="(item, index) in goodsCategory"
      v-show="active == index"
      :key="item.id"
    >
      <h1 class="red">{{ item.name }} | {{ item.title }}</h1>
      <div
        class="container"
        v-for="(item1, i) in item.list"
        :key="item1.id"
        v-show="item1.data.list.length != 0"
      >
        <div class="divRed">
          <span class="spanRed">&nbsp;</span>
          <span>{{ item1.name }}</span>
        </div>

        <div class="win">

        </div>
        <div class="gridBox">
          <div class="children" v-for="(item2, i) in item1.data.list" :key="i">
            <div class="img">
              <img :src="item2.pic" />
              <div class="one"></div>
              <div class="two" v-html="delHtmlTag(item2.name)">
                {{ item2.name }}
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          @current-change="handleCurrentChange($event, i, index)"
          small
          layout="pager"
          :total="item1.data.total"
          :page-size="pageSize"
          v-show="item1.data.total > pageSize"
          :current-page="num"
        >
          <!--:current-page.sync="num"修饰符在属性的最后面.xxxx-->
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "DaotTwo",
  data() {
    return {
      dataList: [1, 2, 3, 4],
      isActive: "",
      dataTlist: [1, 2, 3, 4, 5, 6],
      liList: [1, 2, 3, 4, 5],
      goodsCategory: {},
      pageSize: 180,
      active: 0,
      //默认在第一页
      num: 1,
    };
  },
  methods: {
    delHtmlTag(str) {
      if (str != null) {
        return str.replace(/<[^>]+>/g, "");
      }
    },
    fun(i) {
      (this.active = i), this.getGoodsCategory();
      this.num = 1;
      //每次dom渲染完放入页面,才会执行里面的代码
      this.$nextTick(() => {
        this.num = null;
      });
    },
    async getGoodsCategory() {
      this.goodsCategory = (
        await axios({
          method: "get",
          // url: "/xm/index.php/index/index/getGoodsCategory",
          url: "http://dwj.test.jianong.com/index.php/index/index/getGoodsCategory",
          params: {
            page: 1, //第几页数据
            limit: this.pageSize, // 一页多少个数据
          },
        })
      ).data.data;
      console.log(this.goodsCategory);
    },

    //分页组件的页数一旦改变，就执行这个函数
    async handleCurrentChange(newCurrent, i, index) {
      //应该放这里验证，看看你改变页码对num有没有效
      // console.log(this.num+"num");
      this.goodsCategory[index].list[i].data = (
        await axios({
          method: "get",
          // url: "/xm/index.php/index/index/getGoodsCategory",
          url: "http://dwj.test.jianong.com/index.php/index/index/getGoodsCategory",
          params: {
            page: newCurrent, //第几页数据
            limit: this.pageSize, // 一页多少个数据
          },
        })
      ).data.data[index].list[i].data;
    },
  },
  created() {
    // 默认获取第一页
    this.getGoodsCategory();
  },
};
</script>

<style scoped lang="less">
/deep/.el-tabs__nav-wrap::after {
  background-color: #d7000f;
  width: 50% !important;
}
::-webkit-scrollbar{
  display: none;
}
/deep/ .el-row {
  margin-top: 5vw;
  text-align: center;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space:nowrap;
  .anchor {
    display: inline-block;
    width: 18vw;
    height: 6vw;
    border: 0.0521vw solid #d7000f;
    margin: 0 1.0417vw;
    text-align: center;
    line-height:6vw;
    border-radius: 1.0417vw;
    color: #d7000f;
    font-size: 4vw;
  }


  .active {
    background-color: #d7000f;
    color: #fbefef !important;
  }
}
.gridBox {
  /*margin-top: -32vw;*/
  /*margin-left: 22vw;*/
  width: 90vw!important;
  /*display: flex;*/
  /*background-color: pink;*/
  /*height: 31.2vw;*/
  display: grid;
  /*grid-template-rows: 48vw 48vw 48vw 48vw ;*/
  grid-template-columns: 40vw 40vw;
  grid-gap: 3vw 3vw;

}
.children{
  /*width: 40vw;*/
  height: 50vw;
  box-shadow: 0px 7px 7px -7px #5E5E5E,5px 0px 5px -5px #5E5E5E;
  /*margin: 0 1.8vw 1.8vw 1.8vw;*/
  /*min-width: calc((100% - 1vw) / 2);*/
  /*max-width: calc((100% - 1vw) / 2);*/
}
// 24.5417vw
/deep/ .children:nth-child(n) {
  position: relative;
  border: 0.1042vw solid #e8e8e8;

  .img {
    width: 100%;
    height: 80%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .one {
    position: absolute;
    bottom: 10vw;
    left: 2.5vw;
    width: 6vw;
    height: 0.63vw;
    background-color: #d7000f;
  }
  .two {
    position: absolute;
    left: 2.5vw;
    // bottom: 1.0417vw;
    margin-top: 1vw;
    font-size: 3.3vw;
    width: 35vw;
  }
}
// /deep/ .children:first-child {
//     grid-row-start: span 2;
//     background-color: pink;
// }
/deep/ .el-pager {
  .number {
    margin: 0 0.5208vw;
    border-radius: 100%;
    color: #000000;
    border: 0.0521vw solid #d8d8d8;
    font-weight: 400;
  }
  .active {
    color: #fae9e9;
    background-color: #d7000f;
  }
}

/deep/ .div {
  padding-left: 5.2083vw;
  padding-right: 5.2083vw;
  .container {
    margin-bottom: 7.8125vw;
    position: relative;
    .el-pagination {
      position: absolute;
      right: 0;
      bottom: -2.6042vw;
      li:last-child {
        border-color: #e3e3e3;
      }
    }
  }
  .divRed {
    margin-bottom: 8vw;
    margin-left: 3vw;
  }
  .red {
    font-size: 3.7vw;
    width: 90vw;
    height: 5vw;
    background-image: url("./images/red.png");
    background-size: 60% 100%;
    background-repeat: no-repeat;
    margin-top: 8vw;
    margin-bottom: 5vw;
    line-height: 3.125vw;
    padding-top: 1.8vw;
    padding-left: 1.0417vw;
    color: white !important;
  }
  .spanRed {
    width: 0.3vw;
    height: 2vw;
    background-color: #d7000f;
    color:#d7000f;
    margin-right: 1vw;
  }
  span {
    width: 100%;
    font-size: 4vw;
  }


  .divA {
    display: flex;
    justify-content: space-between;
    height: 31.25vw;
    position: relative;
    .el-pagination {
      position: absolute;
      right: 0;
      bottom: -2.6042vw;
    }

    .l {
      width: 20.8333vw;
      height: 31.25vw;
      background-color: pink;
      margin-right: 1.5625vw;
    }
    .r {
      width: 57.2917vw;
      height: 31.25vw;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: space-between;
      li {
        width: 13.0208vw;
        height: 14.0625vw;
        border: 0.1042vw solid black;
      }
    }
  }
}
</style>
